export const sizeOfBase64 = (base64: string) => {
  const base64str = base64.split(',')[1];
  const  decoded = atob(base64str);
  return decoded.length
}
